import { Row, StyledRowArea, StyledValue } from './styled'

export interface ITradeTipRow {
  title: string
}

export const TradeTipRow: React.FC<ITradeTipRow> = ({ title, children }) => {
  return (
    <StyledRowArea>
      <Row>
        <span>{title}</span>
        <StyledValue>{children}</StyledValue>
      </Row>
    </StyledRowArea>
  )
}
